import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const userSelector = createSelector(rootSelector, v => v.user);
